import { XCircleIcon } from '@heroicons/react/20/solid';
import { useAppDispatch } from '../../../store';
import { uiActions } from '../../ui/slice';
import { BibleManager } from './BibleManager';
import { Modal } from '../../ui/components/Modal';

export const BibleVersionsModal = () => {

  const dispatch = useAppDispatch();
  const closeModal = () => dispatch(uiActions.setCurrentModal(null));

  return (
    <Modal
      height={90}
      hide={closeModal}
      modalKey='bibleManager'
      width={50}
    >
      <button
        className='absolute right-2 top-2 size-8 z-50 text-white'
        onClick={closeModal}
      >
        <XCircleIcon />
      </button>
      <h2 className='text-2xl m-4'>
        Manage Bible versions
      </h2>
      <BibleManager />
    </Modal>
  );
};
